import '../../i18n';
import {useTranslation} from 'react-i18next';
import React, { useState, useEffect } from 'react';

const calculateTimeLeft = (endDate) => {
  if (!endDate) {
    return null;
  }

  const endTime = new Date(endDate).getTime();
  const currentTime = new Date().getTime();

  if (isNaN(endTime)) {
    return null;
  }

  const difference = endTime - currentTime;

  if (difference <= 0) {
    return null;
  }

  const days = Math.floor(difference / (1000 * 60 * 60 * 24));
  const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((difference / 1000 / 60) % 60);
  const seconds = Math.floor((difference / 1000) % 60);

  const result = {
    days,
    hours,
    minutes,
    seconds
  };

  return result;
};

const CountdownTimer = ({ endDate, textColor = 'white' }) => {
    const {t: lnT} = useTranslation();

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(endDate));
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    if (!endDate) {
      return;
    }

    const timer = setInterval(() => {
      const updated = calculateTimeLeft(endDate);
      setTimeLeft(updated);

      if (!updated) {
        clearInterval(timer);
      }
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [endDate]);

  if (!timeLeft) {
    return null;
  }

  // Format the end date for tooltip
  const formatEndDate = (endDate) => {
    const date = new Date(endDate);
    const dateString = date.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
    const timeString = date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      timeZoneName: 'short'
    });
    return { dateString, timeString };
  };

  return (
    <span
      style={{
        fontFamily: 'inherit',
        fontWeight: '600',
        fontSize: 'inherit',
        color: textColor,
        cursor: 'help',
        position: 'relative',
        display: 'inline-block'
      }}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      {timeLeft.days > 0 && lnT('common:d', { value1: String(timeLeft.days) })}
      {timeLeft.hours}{lnT('common:h_17c76396')}{timeLeft.minutes.toString().padStart(2, '0')}{lnT('common:m_62c66a7a')}{showTooltip && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            marginTop: '4px',
            background: 'rgba(0, 0, 0, 0.9)',
            color: '#fff',
            padding: '8px 10px',
            borderRadius: '4px',
            fontSize: '11px',
            zIndex: 9999,
            pointerEvents: 'none',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
            textAlign: 'center'
          }}
        >
          <div style={{ fontWeight: '600', marginBottom: '2px' }}>{lnT('common:ends')}{formatEndDate(endDate).dateString}
          </div>
          <div style={{ opacity: 0.9 }}>
            {formatEndDate(endDate).timeString}
          </div>
          {/* Small arrow pointing up */}
          <div
            style={{
              position: 'absolute',
              bottom: '100%',
              left: '50%',
              transform: 'translateX(-50%)',
              width: 0,
              height: 0,
              borderLeft: '4px solid transparent',
              borderRight: '4px solid transparent',
              borderBottom: '4px solid rgba(0, 0, 0, 0.9)'
            }}
          />
        </div>
      )}
    </span>
  );
};

export default CountdownTimer;